
<div class="k-loading-panel">
  <div class="k-loading-panel-mask"></div>
  <div class="k-loading-panel-wrapper">
    <ng-lottie [options]="options"></ng-lottie>
  </div>
</div>
